import { render } from "./ProductStore.vue?vue&type=template&id=560fa23a"
import script from "./ProductStore.vue?vue&type=script&lang=js"
export * from "./ProductStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__